const PARAMS = () => {
  return {
    addMethod: 0,//1保存草稿 2保存并提交送审 3保存后无需审批
    appId: '',
    ccr: '',
    ccsy: '',//出差事由
    costCenterCode: '',
    costCenterId: '',
    costCenterName: '',
    svalue: '',
    dateBegin: '',
    dateEnd: '',
    mdd: '',//目的地
    project: 0,//是否出差项目
    projectCode: '',
    projectId: '',
    projectName: '',
    remark: '', //备注说明
    sxr: '',// 随行人名称数组字符串
    ccrPerson:[],//出差人数组
    vipPerson: [], // 出行人数组
    vipRoute: [], // 行程数组
    qtys: 0, //其他费用
    jtys: 0, //交通费
    zsys: 0,//住宿费
    zys: 0,//总价
    delRouteIds: '',//删除行程id
    ccsqdId: '',
    ccsqdNo: '',
    delPersonIds: '',//删除的出行人id
    subjectCode: '',//科目码

    gzmc: '',//审批规则名称
    cplx: '',//产品类型
    proType: '',//产品类型
  }
}
const prodParams = () => {
  return { route: [], traverList: [], params: {}}
}
const trip = {
  namespaced: true,
  state: { //state就是Vuex中的公共的状态, 我是将state看作是所有组件的data, 用于保存所有组件的公共数据.
    tk: prodParams(),
    tkInt: prodParams(),
    tr: prodParams(),
    ht: prodParams(),
    params: PARAMS(),
    travelerList:[]
  },
  getters: { //getters属性理解为所有组件的computed属性, 也就是计算属性
    tk: state => state.tk,
    tkInt: state => state.tkInt,
    tr: state => state.tr,
    ht: state => state.ht,
    params: state => state.params,
    travelerList:state => state.travelerList,
  },
  mutations: {
    tk (state, payload) {
      let route = payload.route, params = payload.params
      if (route && route.length > 0 && route[0]) {
        route.forEach(item => {
          /**
                     * 周欣念 2021年8月12日16:01:25
                     * 回显{那就都按单人} 单房间 展示预算
                     *
                     * 周欣念 2021年8月12日17:50:31
                     * 下面展示的票价是单程，上面的预算应该是多个出行人的
                     */
          let price = item.airportFee + item.price.salePrice + item.price.serviceFee,
            num = params.cxrId ? params.cxrId.split(',').length : 1

          state.params.jtys += price * num
          state.tk.params.fyys = price * num

          state.tk.route.push({
            'against': 0,//是否违背0否1是 ,
            'arriveAirport': item.arriveAirport,
            'arriveAirportName': item.arriveAirportName,
            'arriveCity': '',
            'arriveCityName': item.arriveCityName,
            'arriveDate': '',//到达日期/离店日期 ,
            //'arriveEndDate': '',//到达日期/离店日期(范围止) ,
            'arriveTime': item.arriveTime,//
            'cabin': item.cabin ? item.cabin.cabin : '',//舱位/席别/房型
            'cxr': item.cxr || params.cxr,//出行人使用逗号分割 ,
            'cxrId': item.cxrId || params.cxrId,
            'departAirport': item.departAirport,
            'departAirportName': item.departAirportName,
            'departCity': '',//出发城市/入住城市id ,
            'departCityName': item.departCityName,
            'departDate': item.departDate,//出发日期/入住日期 ,
            //'departEndDate': item.departEndDate,// 出发日期/入住日期(范围止) ,
            'departTime': item.departTime,
            'flightNo': item.flightNo,// 航班号/车次/酒店名称 ,
            'fyys': item.fyys || price,//费用预算
            'isChange': '',//是否变更
            'proType': '10901',//产品代码来自b_class ,
            'routeId': '',
            'routeStatus': '',
            'travelStandard': '',//出差标准 ,
            'violateitem': '',
            'violateitemCode': '',
            'wbyy': '',//违背原因备注说明 ,
            'xcxh': '',//行程序号 ,
            'yroId': ''//原行程id
          })
        })
      } else {
        let obj = {
          'arriveAirport': params.arrport.threeCode,
          'cxr': params.cxr,//出行人使用逗号分割 ,
          'cxrId': params.cxrId,
          'departAirport': params.depport.threeCode,
          'departDate': params.departDate,//出发日期/入住日期 ,
          'proType': '10901',
        }
        let bl = false
        if (state.tk.route.length == 0) {
          bl = true
        } else {
          bl = state.tk.route.every(item => {
            var cache = false
            for (var k in obj) {
              if (item[k] != obj[k]) {
                cache = true
              }
            }
            return cache
          })
        }
        if (bl && params.departDate && params.depport.threeCode && params.arrport.threeCode && params.cxr) {
          Object.assign(obj, {
            'arriveAirportName': params.arrport.airportName,
            'arriveCityName': params.arrport.cityName,
            'departAirportName': params.depport.airportName,
            'departCityName': params.depport.cityName,
            'fyys': params.fyys,//费用预算
          })
          state.params.jtys += params.fyys||0
          state.tk.route.push(obj)
        }
      }
    },
    tkInt (state, payload) {
      let route = payload.route, params = payload.params
      if (route && route.length > 0 && route[0]) {
        let ps = (cache, cabin, price) => {
          state.tkInt.route.push({
            'against': 0,//是否违背0否1是 ,
            'arriveAirport': cache.arriveAirport,
            'arriveAirportName': cache.arriveAirportName,
            'arriveCity': '',
            'arriveCityName': cache.arriveCityName,
            'arriveDate': cache.arriveDate,//到达日期/离店日期 ,
            //'arriveEndDate': cache.arriveEndDate,//到达日期/离店日期(范围止) ,
            'arriveTime': cache.arriveTime,//
            'cabin': cabin.cabin,//舱位/席别/房型
            'cxr': cache.cxr || params.cxr,//出行人使用逗号分割 ,
            'cxrId': cache.cxrId || params.cxrId,
            'departAirport': cache.departAirport,
            'departAirportName': cache.departAirportName,
            'departCity': '',//出发城市/入住城市id ,
            'departCityName': cache.departCityName,
            'departDate': cache.departDate,//出发日期/入住日期 ,
            //'departEndDate': cache.departEndDate,// 出发日期/入住日期(范围止) ,
            'departTime': cache.departTime,
            'flightNo': cache.flightNo,// 航班号/车次/酒店名称 ,
            'fyys': cache.fyys || price,//费用预算
            'isChange': '',//是否变更
            'proType': '10902',//产品代码来自b_class ,
            'routeId': '',
            'routeStatus': '',
            'travelStandard': '',//出差标准 ,
            'violateitem': '',
            'violateitemCode': '',
            'wbyy': '',//违背原因备注说明 ,
            'xcxh': '',//行程序号 ,
            'yroId': ''//原行程id
          })
        }
        state.tkInt.route.forEach(item => {
          let price = item.price.aduSalePrice + item.price.aduServicefee + item.price.aduTax,
            num = params.cxrId ? params.cxrId.split(',').length : 1

          state.params.jtys += price * num
          state.tkInt.params.fyys = price * num

          if (item.hflightBean) {
            let cache = item.hflightBean
            ps(cache, item.cabin, price)
          } else if (item.qflightBean) {
            let cache = item.qflightBean
            ps(cache, item.cabin, price)
          }
        })
      } else {
        let obj={
          'arriveAirport': params.arrport.threeCode,
          'arriveDate': params.arriveDate,//到达日期/离店日期 ,
          'cxr': params.cxr,//出行人使用逗号分割 ,
          'cxrId': params.cxrId,
          'departAirport': params.depport.threeCode,
          'departDate': params.departDate,//出发日期/入住日期 ,
          'proType': '10902',
        }
        let bl=false
        if(state.tkInt.route.length==0){
          bl=true
        } else{
          bl = state.tkInt.route.every(item => {
            var cache=false
            for (var k in obj) {
              if (item[k] != obj[k]) {
                cache = true
              }
            }
            return cache
          })
        }
        if (bl && params.departDate && params.depport.threeCode && params.arrport.threeCode && params.cxr) {
          Object.assign(obj, {
            'arriveAirportName': params.arrport.airportName,
            'arriveCityName': params.arrport.cityName,
            'departAirportName': params.depport.airportName,
            'departCityName': params.depport.cityName,
            'fyys': params.fyys,//费用预算
          })
          state.params.jtys += params.fyys || 0
          state.tkInt.route.push(obj)
        }
      }
    },
    tr (state, payload) {
      let route = payload.route, params = payload.params
      if (route && route.length > 0 && route[0]) {
        route.forEach(item => {
          let cache = item.TrainDetail || {},
            num = params.cxrId ? params.cxrId.split(',').length : 1

          state.params.jtys += item.SeatDetail.price * num
          state.tr.params.fyys = item.SeatDetail.price * num

          state.tr.route.push({
            'against': item.SeatDetail ? item.SeatDetail.wb : '',//是否违背0否1是 ,
            'arriveAirport': cache.toStationCode || item.arriveAirport,
            'arriveAirportName': cache.toStationName || item.arriveAirportName,
            'arriveCity': '',
            'arriveCityName': item.arriveCityName,
            'arriveDate': '',//到达日期/离店日期 ,
            'arriveTime': '',//
            'cabin': item.SeatDetail ? item.SeatDetail.seatType : '' || item.cabin,//舱位/席别/房型
            'cxr': item.cxr || params.cxr,//出行人使用逗号分割 ,
            'cxrId': item.cxrId || params.cxrId,
            'departAirport': cache.fromStationCode || item.departAirport,
            'departAirportName': cache.fromStationName || item.departAirportName,
            'departCityName': item.departCityName || params.departCityName,
            'departDate': cache.byTrainDate || item.departDate,//出发日期/入住日期 ,
            'departTime': cache.startTime || item.departTime,
            'flightNo': cache.trainCode || item.flightNo,// 航班号/车次/酒店名称 ,
            'fyys': item.fyys || item.SeatDetail.price,//费用预算
            'isChange': '',//是否变更
            'proType': '10904',//产品代码来自b_class ,
            'routeId': '',
            'routeStatus': '',
            'travelStandard': '',//出差标准 ,
            'violateitem': '',
            'violateitemCode': '',
            'wbyy': '',//违背原因备注说明 ,
            'xcxh': '',//行程序号 ,
            'yroId': ''//原行程id
          })
        })
      } else {
        let obj = {
          'cxr': params.cxr,//出行人使用逗号分割 ,
          'cxrId': params.cxrId,
          'departDate': params.departDate,//出发日期/入住日期 ,
          'proType': '10904',
        }
        let bl = false
        if (state.tr.route.length == 0) {
          bl = true
        } else {
          bl = state.tr.route.every(item => {
            var cache = false
            for (var k in obj) {
              if (item[k] != obj[k]) {
                cache = true
              }
            }
            return cache
          })
        }
        if (bl && params.departDate && params.depport.threeCode && params.arrport.threeCode && params.cxr) {
          Object.assign(obj, {
            'arriveAirport': params.arrport.threeCode,
            'departAirport': params.depport.threeCode,
            'arriveCityName': params.arrport.cityName,
            'departCityName': params.depport.cityName,
            'fyys': params.fyys,//费用预算
          })
          state.params.jtys += params.fyys
          state.tr.route.push(obj)
        }
      }
    },
    ht (state, payload) {
      let route = payload.route, params = payload.params
      if (route && route.length > 0 && route[0]) {
        route.forEach(item => {
          // if (!params.fyys || params.fyys == 0) {
          if (item._ratePlans) {
            state.params.zsys += item._ratePlans.totalRate * params.fjs // (params._days * params.fjs*(item._ratePlans?item._ratePlans.firstPrice:1))
            state.ht.params.fyys = item._ratePlans.totalRate * params.fjs
          }

          /**
           * 这里导致添加新的行程预算价格还是用的上一个预算价格
           * 先注释掉看看
           */
          // } else {
          // 	state.params.zsys += (params.fyys - 0) || 0
          // 	state.ht.params.fyys = (params.fyys - 0) || 0
          // }
          let against = item._violation ? (item._violation.violateitem ? 1 : 0) : 0
          state.ht.route.push({
            'against': against,//是否违背0否1是 ,
            'arriveAirport': '',
            'arriveAirportName': '',
            'arriveCity': '',
            'arriveCityName': '',
            'arriveDate': item.checkOutDate || item.arriveDate,//到达日期/离店日期 ,
            //'arriveEndDate': '',//到达日期/离店日期(范围止) ,
            'cabin': item._ratePlans ? item._ratePlans.roomId : '',//舱位/席别/房型
            'cxr': item.cxr || params.cxr,//出行人使用逗号分割 ,
            'cxrId': item.cxrId || params.cxrId,
            'departAirport': '',
            'departAirportName': '',
            'departCity': item.cityId || item.departCity,//出发城市/入住城市id ,
            'departCityName': item.cityIdName || item.departCityName,
            'departDate': item.checkInDate || item.departDate,//出发日期/入住日期 ,
            //'departEndDate': '',// 出发日期/入住日期(范围止) ,
            'departTime': '',
            'dj': item._ratePlans ? item._ratePlans.firstPrice : '',//单价 ,
            'fjs': params.fjs||1,//房间数 ,
            'flightNo': item.jdmc || item.flightNo,// 航班号/车次/酒店名称 ,
            'fyys': item.fyys || state.ht.params.fyys,//费用预算
            'isChange': '',//是否变更
            'proType': '10903',//产品代码来自b_class ,
            'routeId': '',
            'routeStatus': '',
            'travelStandard': '',//出差标准 ,
            'violateitem': item._violation ? item._violation.violateitem : '',
            'violateitemCode': item._violation ? item._violation.reasonCode : '',
            'wbyy': item._violation ? item._violation.reasonDesc : '',//违背原因备注说明 ,
            'xcxh': '',//行程序号 ,
            'yroId': ''//原行程id
          })
        })
      } else {
        let obj = {
          'arriveDate': params.arriveDate,//到达日期/离店日期 ,
          'cxr': params.cxr,//出行人使用逗号分割 ,
          'cxrId': params.cxrId,
          'departCity': params.depport.id || params.depport.cityId,
          'departDate': params.departDate,//出发日期/入住日期 ,
          'fjs': params.fjs,
          'proType': '10903',
        }
        let bl = false
        if (state.ht.route.length == 0) {
          bl = true
        } else  {
          bl = state.ht.route.every(item => {
            var cache = false
            for (var k in obj) {
              if (item[k] != obj[k]) {
                cache = true
              }
            }
            return cache
          })
        }
        if (bl && params.departDate && params.depport.cityName && params.cxr) {
          Object.assign(obj, {
            'departCityName': params.depport.cityName,
            'fyys': params.fyys,//费用预算
          })
          state.params.zsys += params.zsys||0
          state.ht.route.push(obj)
        }
      }
    },
    params (state, payload) {
      Object.assign(state.params , payload)
    },
    travelerList (state, payload) {
      state.travelerList = payload
    },
    CLEAR_TK (state) {  state.tk = prodParams()},
    CLEAR_TKINT (state) {  state.tkInt = prodParams()},
    CLEAR_TR (state) {  state.tr = prodParams()},
    CLEAR_HT (state) {  state.ht = prodParams()},
    CLEAR_PARAMS (state) {  state.params = PARAMS()},
    CLEAR_TRAVELERlIST (state) {  state.travelerList = []},
    CLEAR_ALL (state) {
      state.tk = prodParams()
      state.tkInt = prodParams()
      state.tr = prodParams()
      state.ht = prodParams()
      state.travelerList = []
    }
  },
  actions: { /*添加actions actions中可以包含异步操作 */

  }
}
export default trip
